<template>
  <div class="login">
	<p class="loginTit">欢迎使用 一鸣 在线音乐系统</p>
    <div class="resetForm">
		<div class="logo">
			<img src="../assets/inm_logo.png" class="inmLogo" />
		</div>
		<div class="username2 mt-15">
			<div class="userTxt2">店铺编号</div>
			<input class="user2" v-model="shopCode" placeholder="请输入9位店铺编号" />
		</div>
		<div class="username2">
			<div class="userTxt2">手机号</div>
			<input class="user2" v-model="mobile" placeholder="请输入手机号" />
		</div>
		<div class="password2">
			<div class="userTxt2">新密码</div>
			<input class="passwordInput2" autocomplete="new-password" v-model="password" type="password" placeholder="请输入密码" />
		</div>
		<div class="password2">
			<div class="userTxt2">确认密码</div>
			<input class="passwordInput2" autocomplete="new-password" v-model="password2" type="password" placeholder="请再次输入密码" />
		</div>
		
		<div class="loginBtn" @click="handleSure">
			确 认 重 置 密 码
		</div>
		
	</div>
  </div>
</template>

<script>
import { resetPwd } from '../request/api.js'
const FIXED_SMS_CODE = '666666'
export default {
  name: 'Home',
  components: {
    
  },
  data(){
	  return{
		  password:'',
		  password2:'',
		  shopCode:'',
		  mobile:''
	  }
  },
  methods:{
	  async handleSure(){
		  if(!this.password2||!this.password||!this.shopCode||!this.mobile){
			  this.toast('表单数据不完整');
			  return;
		  }
		  if(this.password2!=this.password){
			  this.toast('两次密码不一致');
			  return;
		  }
		const res =  await resetPwd({
			password:this.password,
			regionCode:FIXED_SMS_CODE,
			mobile:this.mobile,
			shopCode:this.shopCode
		}).then(res => {
			if(res.code == 0){
				this.toast('重置密码成功');
				setTimeout(()=>{
							 this.$router.push({
							 	     path: '/login',
							 	 })
							 
				},1200)
				
			}
		})
	  }
  }
}
</script>
